import PageContext from "global_state/context/PageContext"
import { useContext, useEffect, useState } from "react"
import { getPaymentGetwayService } from "services/GetPaymentGetwayService"
import { PaymentsType } from "types/PaymentsI"
import { ProductI, SpecialOfferI } from "types/ProductI"
import { FaShoppingBasket } from "react-icons/fa"


import SCSS from 'assets/scss/Eshop.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'

import content from 'languages/Product.json'
import { PopUpType } from "types/PageI"
import { format_price_number } from "services/functions"
import UserContext from "global_state/context/UserContext"



function Product(props: any) {
    const {page, dispatchPage} = useContext(PageContext)
    const {user} = useContext(UserContext)
    let language = page.settings.language
    
    const [buy_membership_response, setBuyMembershipResponse] = useState<any>()

    const handleBuyMembership = async (e) => {
        e.preventDefault()
        // console.log('buy product with id:' + props.product.product_id);
        
        // open pop up with calendar
        // console.log(e);
        
        dispatchPage({
            type: "set_popup",
            payload: {
                popup: PopUpType.buy_membership,
                props: {
                    product: props.product

                }
            }
        })


        return 
    }
    const renderSpecialOffer = () => {
        if (props.special_offer) {
            return (
                <div className={SCSS.special_offer_text}>
                    {content[language].special_offer_text}
                </div>
            )
        } 
        return null
    }
    const specialOfferClass = () => {
        if (props.special_offer) {
            return SCSS.special_offer
        }
        return ""
    }
    return (
        <div key={props.index} className={[SCSS.product, specialOfferClass()].join(" ")}>
            {renderSpecialOffer()}
            <div className={SCSS.name}>{props.product.name}</div>
            <div className={SCSS.description}>{props.product.description[language]}</div>
            <div className={SCSS.price}>
                {format_price_number(props.product.price_registration || '')}
                <span> Kč</span>
            </div>
            <button 
                className={[AppSCSS.button, AppSCSS.white, AppSCSS.bolder, SCSS.buy_button].join(" ")}
                onClick={(e) => handleBuyMembership(e)}>
                
                <FaShoppingBasket></FaShoppingBasket>   
                {content[language].button_text}

            </button>
        </div>
    )
}

export default Product